import Loading from '../Loading'
import { LoadingButtonProps } from './types'
import * as S from './styles'

const LoadingButton = ({
  id,
  primary,
  outline,
  children,
  disabled,
  onClick,
  isLoading,
  width,
  ...restAttributes
}: LoadingButtonProps) => {
  return (
    <S.CustomButton
      id={id}
      primary={primary}
      outline={outline}
      disabled={disabled || isLoading}
      onClick={onClick}
      width={width}
      {...restAttributes}
    >
      {isLoading ? <Loading spinner /> : children}
    </S.CustomButton>
  )
}
export default LoadingButton
